export default "__VITE_ASSET__CXlVx6x5__"